import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Compare for Yourself',
  name: 'compare',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'Compare for yourself',
    }),
    defineField({
      title: 'Compare Table',
      name: 'table',
      type: 'table',
    }),
    defineField({
      title: 'Table Highlight Column',
      name: 'highlight',
      type: 'number',
      initialValue: 1,
    }),
    defineField({
      title: 'Footer',
      name: 'footer',
      type: 'array',
      of: strongEmLink,
    }),
  ],
})